"use client";

import {
  BarChart3,
  Boxes,
  CreditCard,
  Home,
  PackageCheck,
  Settings,
  Star,
  Wallet,
} from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "@/lib/utils";

const links = [
  { href: "/vendor", label: "Overview", icon: Home },
  { href: "/vendor/products", label: "Products", icon: Boxes },
  { href: "/vendor/orders", label: "Orders", icon: PackageCheck },
  { href: "/vendor/earnings", label: "Earnings", icon: BarChart3 },
  { href: "/vendor/withdrawals", label: "Withdrawals", icon: Wallet },
  { href: "/vendor/reviews", label: "Reviews", icon: Star },
  { href: "/vendor/settings", label: "Store settings", icon: Settings },
  { href: "/", label: "Storefront", icon: CreditCard },
];

export function VendorShell({ children, title }: { children: React.ReactNode; title: string }) {
  const pathname = usePathname();

  return (
    <div className="mx-auto grid max-w-amazon gap-6 px-3 py-8 sm:px-4 lg:grid-cols-[240px_1fr]">
      <aside className="amazon-card h-fit p-2">
        <div className="px-3 py-2">
          <p className="text-xs font-bold uppercase text-amazon-orange">Seller Central</p>
          <h1 className="text-xl font-bold">{title}</h1>
        </div>
        <nav className="mt-1 flex flex-row gap-1 overflow-x-auto lg:flex-col lg:overflow-visible no-scrollbar">
          {links.map((link) => {
            const Icon = link.icon;
            const active = pathname === link.href;
            return (
              <Link
                key={link.href}
                href={link.href}
                className={cn(
                  "flex shrink-0 items-center gap-2 rounded px-3 py-2.5 text-sm font-medium transition",
                  active ? "bg-amazon-navy text-white dark:bg-white/10" : "text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-white/5",
                )}
              >
                <Icon className="h-4 w-4" />
                {link.label}
              </Link>
            );
          })}
        </nav>
      </aside>
      <main className="min-w-0">{children}</main>
    </div>
  );
}
